export const colors = {
  brandPrimaryDefault: "#0070EB",
  brandPrimaryTint: "#C8E2FF",
  brandPrimaryShade: "#004EA3",
  brandGradientDefault: "linear-gradient(125deg, #2B2D2E 0%, #0a0a0a 100%)",
  brandGradientColorStopsStart: "#2B2D2E",
  brandGradientColorStopsEnd: "#0a0a0a",
  contentBrandPrimary: "#0070EB",
  contentLink: "#2B90FF",
  backgroundBrand: "#0070EB",
  borderBrand: "#0070EB",
  linkDefaultBase: "#2B90FF",
  componentButtonPrimaryContentDisabled: "#0a0a0a",
  componentButtonPrimaryBackgroundDisabled: "#3C3E40",
  componentTabPrimaryLabelActive: "#2B90FF",
  componentTabPrimaryIndicatorActive: "#2B90FF",
  componentTabPrimaryIconActive: "#2B90FF",
};

export const text = {
  themeName: "Sportsbook Dark",
};